import { React,useEffect, useState } from 'react';
import '../styles/ConfirmImpressao.css'; // Adicione um CSS para a modal, se necessário

const ConfirmImpressao = ({ message, onConfirm, onCancel }) => {

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onConfirm();
    }
    if (event.key === 'Esc') {
      onCancel();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p>{message}</p>
        <div id='button-group'>
          <button className='button' onClick={onConfirm}>Sim</button>
          <button className='button' style={{ backgroundColor: "red", color: "white" }} onClick={onCancel}>
            Não
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmImpressao;
